import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
};
type GetAlldFAQResponse = {
 
  data: any[];
  totalCount: number;
};

type GetTokenParams = {
  wpagination?: boolean;
  limit?: number;
  page?: number;
  query?: string;
  categoryType?: number;
};
export const FAQApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getFAQ: builder.query<
      CommonResponseType & { data: GetAlldFAQResponse },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.faq}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ""
        }`,
        method: "GET",
      }),
    }),
    getFAQById: builder.query<
      CommonResponseType & { data: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.faq}/${id}`,
        method: "GET",
      }),
    }),
    addFAQ: builder.mutation<CommonResponseType, CommonBody>({
      query: (body) => ({
        url: END_POINTS.faq,
        method: "POST",
        body,
      }),
    }),
    updateFAQById: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; body: CommonBody }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.faq}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteFAQById: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.faq}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetFAQQuery,
  useLazyGetFAQByIdQuery,
  useAddFAQMutation,
  useUpdateFAQByIdMutation,
  useDeleteFAQByIdMutation,
} = FAQApi;
